import { TRating } from '../../types/rating';
import { ITypedReduxAction } from '../../../common/types/redux/actionType';

export enum ERatingActionTypes {
  Loading = 'rating/loading',
  Succeed = 'rating/succeed',
  Failed = 'rating/failed',
}

export type TGetRatingLoading = ITypedReduxAction<ERatingActionTypes.Loading>;
export type TGetRatingSucceed = ITypedReduxAction<ERatingActionTypes.Succeed, TRating[]>;
export type TGetRatingFailed = ITypedReduxAction<ERatingActionTypes.Failed>;

export type TGetRating = TGetRatingLoading | TGetRatingSucceed | TGetRatingFailed;
